import React, { useState, useEffect } from "react";

import { Row, Column } from "components/Layout";
import NTMSelect from "components/Buttons/NTMSelect";
import ElementModal from "./ElementModal";
import style from './_modal.module.scss';


export default function AgrismartDeviceModal({
	isOpen, onClose, onSubmit, deviceFields,
}) {
	const [id, setId] = useState()
	const [device, setDevice] = useState() // seriale centralina
	const [type, setType] = useState()
	const [label, setLabel] = useState()
	const [lat, setLat] = useState()
	const [lng, setLng] = useState()

	useEffect(() => {
		setId(deviceFields?.id)
		setDevice(deviceFields?.device)
		setType(deviceFields?.type || 0)
		setLabel(deviceFields?.label)
		setLat(deviceFields?.lat)
		setLng(deviceFields?.lng)
	}, [deviceFields])

	function submit() {
		let submitFields = {
			device,
			type,
			label,
			lat,
			lng,
		}
		onSubmit(submitFields)
	}

	return (
		<ElementModal isOpen={isOpen} onClose={onClose} submit={submit}>
			{
				id ? (
					<Column className={style.section}>
						<Row className={style.title}>
							{`CENTRALINA ${device}`}
						</Row>
					</Column>
				) : null
			}
			<Column className={style.section}>
				<Row className={style.fields}>
					Tipo
					<NTMSelect
						value={type || undefined}
						onChange={e => setType(e.target.value)}
					>
						<option value={0}>-</option>
						<option value={1}>RIF</option>
						<option value={2}>A</option>
						<option value={3}>B</option>
					</NTMSelect>
				</Row>
				<Row className={style.fields}>
					Label
					<input
						type={"text"}
						placeholder={"Nome dispositivo"}
						onChange={e => setLabel(e.target.value)}
						value={label}
					/>
				</Row>
			</Column>
			<Column className={style.section}>
				<Row className={style.title}>
					Posizione geografica
				</Row>
				<Row className={style.fields}>
					Latitudine
					<input
						type={"number"}
						onChange={e => setLat(e.target.value)}
						value={lat}
						step={0.001}
					/>
				</Row>
				<Row className={style.fields}>
					Longitudine
					<input
						type={"number"}
						onChange={e => setLng(e.target.value)}
						value={lng}
						step={0.001}
					/>
				</Row>
			</Column>
		</ElementModal>
	)
}
